
import Vue from 'vue'
import UsersList from '@/components/admin/UsersList.vue'

export default Vue.extend({
  name: 'Admin',
  components: { UsersList },
  methods: {},
  computed: {},
})
